// Ready-made messages for sharing a donation page. Each says who's
// reading, that it raises money for the school, and where to give —
// phrased to read right whether it's sent before, during or after the
// campaign. Donations are fixed amounts, so nothing implies "per page"
// or "per minute" pledges.

// For a parent sharing their child's page with family and friends.
export function buildShareMessages({ firstName, schoolName, url }) {
  return [
    {
      kind: "note",
      label: "A note to family",
      body: `${firstName} is doing a read-a-thon to raise money for ${schoolName}. If you'd like to cheer them on, you can donate on their page: ${url}`,
    },
    {
      kind: "short",
      label: "Short and direct",
      body: `Support ${firstName}'s read-a-thon for ${schoolName}: ${url}`,
    },
    {
      kind: "context",
      label: "A bit more context",
      body: `${firstName} is reading as much as they can to help raise money for ${schoolName}. Every donation goes straight to the school. Here's their page: ${url}`,
    },
  ];
}

// For school staff: newsletters, parent emails, community posts — the
// read-a-thon as the whole school's effort.
export function buildSchoolShareMessages({ schoolName, url }) {
  return [
    {
      kind: "newsletter",
      label: "For a newsletter",
      body: `${schoolName} is running a read-a-thon to raise money for our school. You can follow our progress and donate at ${url}.`,
    },
    {
      kind: "short",
      label: "Short and direct",
      body: `Donate to ${schoolName}'s read-a-thon: ${url}`,
    },
    {
      kind: "context",
      label: "A bit more context",
      body: `Our students are reading to raise money for ${schoolName}. If you'd like to support the school, you can donate here: ${url}`,
    },
  ];
}

export function shuffle(arr) {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function buildSmsHref(body) {
  return `sms:?&body=${encodeURIComponent(body)}`;
}
